const formatCurrency = (amount, { hideCents = false } = {}) => {
  const value = `$${Number(amount)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`

  return hideCents ? value.replace(/\.[0-9]{2}$/, '') : value
}

export default formatCurrency
